import React from 'react'
import BookingConfirmed from './BookingConfirmed'

const indexBooking = () => {
  return (
    <div style={{ fontFamily: 'Nunito Sans' }}>
      <BookingConfirmed/>
    </div>
  )
}

export default indexBooking
